import config from '../config';

const pixlee = config({
  default: {
    default: {
      /** Whether the pixlee integration is enabled. */
      enabled: false,
      /** The apiKey for the pixlee account. */
      apiKey: '',
      /** The clientID for the pixlee account. */
      clientID: '',
      /** The account ID for the pixlee account. */
      accountID: '',
      /** The page widget for the pixlee account, these ids load different widgets, we will probably need to allow for more than one. */
      pageWidget: '',
      /** The script for the pixlee account. */
      script: 'https://assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js',
      /**
       * The type of widget to use. Can be 'category' or 'page'.
       */
      type: 'category'
    }
  },
  'HOKA-US': {
    default: {
      clientID: 'hok',
      apiKey: '9o8ihj6s7WljvnDXOWHU',
      accountID: 1564,
      pageWidget: 2599100
    }
  },
  'UGG-US': {
    default: {
      clientID: 'ugg',
      apiKey: 'iWwqsXtBIAjaTk7Kifyd',
      accountID: 1887,
      pageWidget: 4713381
    }
  },
  'TEVA-US': {
    default: {
      enabled: true,
      clientID: 'tva',
      apiKey: 'RlyfxAahdfWmD3kX1jKS',
      accountID: 1913,
      pageWidget: 5227029
    }
  }
});

export default pixlee;
